const KEY = 'profile'

export function getProfile() {
  return JSON.parse(localStorage.getItem(KEY))
}

export function setProfile(profile) {
  return localStorage.setItem(KEY, JSON.stringify(profile))
}

export function removeProfile() {
  return localStorage.removeItem(KEY)
}
